export default {
  state: {
    set perm(arr) {
      localStorage.setItem("perm", JSON.stringify(arr));
    },
    get perm() {
      const perm = localStorage.getItem("perm");
      return perm ? JSON.parse(perm) : [];
    },
  },
  mutations: {
    setPerm(state, arr) {
      state.perm = arr;
    },
  },
};
